import type { ReactNode } from "react";

interface EyebrowProps {
	children: ReactNode;
}

/** Small uppercase brand label above a section heading. */
function Eyebrow(prop: EyebrowProps) {
	const { children } = prop;
	return (
		<p className="text-xs font-semibold uppercase tracking-[0.14em] text-(--brand-2)">{children}</p>
	);
}

export default Eyebrow;
